import { render, staticRenderFns } from "./FilingContent.vue?vue&type=template&id=838505ce&"
import script from "./FilingContent.vue?vue&type=script&lang=js&"
export * from "./FilingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports